// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Tvlsn","col":"styles_col__2UI4X"};